/**
 * Dev-mode utility to ensure Firestore payloads only contain allowed keys.
 * Helps prevent accidental persistence of restricted Places attributes (ToS compliance).
 */
export const assertKeysOnly = (
    label: string,
    obj: Record<string, any>,
    allowedKeys: string[]
) => {
    if (process.env.NODE_ENV === "production") return;

    const extras = Object.keys(obj).filter(k => !allowedKeys.includes(k));
    if (extras.length) {
        // eslint-disable-next-line no-console
        console.warn(`[ToS Guard] ${label} has unexpected keys:`, extras);
    }
};
